import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import HomePage from '@/pages/HomePage';
import GardenPage from '@/pages/GardenPage';
import GalleryPage from '@/pages/GalleryPage';
import ContactPage from '@/pages/ContactPage';
import AdminPage from '@/pages/AdminPage';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import '@/App.css';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        {/* SEOSchema is now rendered per-page, not globally, to ensure correct canonical/hreflang */}
        <BrowserRouter>
          <Navigation />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/garden" element={<GardenPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;